export const appConfig = {
  brandName: "Converto",
  headline: "Sistemas inteligentes para processos reais.",
  targetFile: "/assets/targets/converto-card.mind",
  logoFile: "/assets/branding/logo-converto.png",
  whatsappUrl: "https://wa.me/351938443125",
  targetIndex: 0,
  analyticsEnabled: true,
} as const;
